import React from 'react'
import PropTypes from 'prop-types'
import Text from '@hixme-ui/text'

import classes from './ProductCard.module.scss'

const AutomaticallyAddedCallout = ({ children }) => (
  <div className={classes.autoAdded}>
    <Text large light>
      Automatically Added to Cart
    </Text>
    <Text light thin div>
      {children}
    </Text>
  </div>
)

AutomaticallyAddedCallout.displayName = 'AutomaticallyAddedCallout'
AutomaticallyAddedCallout.propTypes = {
  children: PropTypes.node,
}
AutomaticallyAddedCallout.defaultProps = {
  children: 'Your employer is providing this coverage at no cost to you.',
}

export default AutomaticallyAddedCallout
